export type EventType =
  | 'progress'
  | 'materialsCheck'
  | 'contractSign'
  | 'startProject'
  | 'endProject'
  | 'startWork'
  | 'endWork'
  | 'finalEndWork';

const eventKeyTypeMap = {
  materials_check: 'materialsCheck',
  contract_sign: 'contractSign',
  expected_start: 'startProject',
  expected_end: 'endProject',
  start: 'startWork',
  end: 'endWork',
  adjusted_end: 'finalEndWork'
};

const eventTypeLabelMap = {
  materialsCheck: 'Validation des matériaux le',
  contractSign: 'Signature de contrat',
  startProject: 'Date de démarrage',
  endProject: 'Date de fin de chantier prévisionnelle',
  startWork: 'Chantier démarré le',
  endWork: 'Date de fin de chantier contractuelle',
  finalEndWork: 'Date de fin de chantier recallée'
};

export type Event = {
  label: string;
  date: string;
  type: EventType;
};

export function getEvent(key: string, date: string): Event | null {
  const type = eventKeyTypeMap[key];
  if (type === undefined || !date || date === 'null') {
    return null;
  }

  const event: Event = {
    date,
    type,
    label: eventTypeLabelMap[type]
  };

  return event;
}
